module.exports = __webpack_public_path__ + "a94274df9db016e4d08b766b158bdf4e.mp4";